/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-22 14:31:25
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-07-07 16:19:12
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/SalesChannelMultiLanguageSelect/slice/index.ts
 */
import {
  createSlice,
  createSelector,
  createAsyncThunk,
} from '@reduxjs/toolkit';
import { getSalesChannelStyle } from 'src/request/common';
import { EnumReducers } from 'src/store/constants';
//import { get } from 'lodash';
import { WebSiteSubType } from 'src/types/common/SalesChannel';

const target = (state) => {
  return state[EnumReducers.nativeSalesChannelTypeSelector];
};

export const fetchSalesChannelAvailableStyles = createAsyncThunk(
  'fetchSalesChannelAvailableStyles',
  async (data: { salesChannelUuid: string }) => {
    const { salesChannelUuid } = data;

    const response = await getSalesChannelStyle(salesChannelUuid);
    return { response, salesChannelUuid };
  },
);

export const fetchSalesChannelSpecificStyles = createAsyncThunk(
  'fetchSalesChannelSpecificStyles',
  async (data: any) => {
    const { salesChannelUuid, body, uuid, reduxAccessKeys } = data;

    const response = await getSalesChannelStyle(body);
    return { response, salesChannelUuid, uuid, reduxAccessKeys };
  },
);

const defaultData = {
  salesChannelUuid: null,
  selectedStyle: null,
  styleList: [],
  pages: {},
};

const SalesChannelStyleSelect = createSlice({
  name: 'SalesChannelStyleSelect',
  initialState: defaultData,
  reducers: {
    updateLanguageList(state, action) {
      console.log(action);
    },
    updateSelectedStyle(state, action) {
      const { salesChannelUuid, selectedStyle } = action.payload;
      if (state.salesChannelUuid === salesChannelUuid) {
        state.selectedStyle = selectedStyle;
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      fetchSalesChannelAvailableStyles.fulfilled,
      (state, action) => {
        const { response, salesChannelUuid } = action.payload;
        const styleList = response.map((i) => i.siteStyle);
        if (state.salesChannelUuid !== salesChannelUuid) {
          state.salesChannelUuid = salesChannelUuid;
          if (styleList.includes(WebSiteSubType.ResponsivePage)) {
            state.selectedStyle = WebSiteSubType.ResponsivePage;
          } else {
            state.selectedStyle = WebSiteSubType.NativeMobile;
          }
          state.pages = {};
          state.styleList = response;
        }
      },
    );
    builder.addCase(
      fetchSalesChannelSpecificStyles.fulfilled,
      (state, action) => {
        const { uuid, response, reduxAccessKeys, salesChannelUuid } =
          action.payload;
        const styleList = response.map((i) => i.siteStyle);
        if (state.salesChannelUuid !== salesChannelUuid) {
          state.salesChannelUuid = salesChannelUuid;
          if (styleList.includes(WebSiteSubType.ResponsivePage)) {
            state.selectedStyle = WebSiteSubType.ResponsivePage;
          } else {
            state.selectedStyle = WebSiteSubType.NativeMobile;
          }
          state.pages = {};
          state.styleList = response;
        }

        reduxAccessKeys.forEach((i) => {
          state.pages[`${uuid}${i}`] = response;
        });
      },
    );
  },
});

const currentSalesChannelUuid = () => {
  return createSelector(
    (state: any) => {
      return target(state).salesChannelUuid;
    },
    (salesChannelUuid) => {
      return salesChannelUuid;
    },
  );
};

const currentSelectedStyle = () => {
  return createSelector(
    (state: any) => {
      return target(state).selectedStyle;
    },
    (selectedStyle) => {
      return selectedStyle;
    },
  );
};

const getPageStyleList = (key) => {
  return createSelector(
    (state: any) => {
      return target(state).pages[key];
    },
    (pages) => {
      return pages;
    },
  );
};

const getCurrentStyleList = () => {
  return createSelector(
    (state: any) => {
      return target(state).styleList;
    },
    (styleList) => {
      return styleList;
    },
  );
};

export {
  currentSalesChannelUuid,
  getCurrentStyleList,
  getPageStyleList,
  currentSelectedStyle,
};
export const { updateLanguageList, updateSelectedStyle } =
  SalesChannelStyleSelect.actions;

export default SalesChannelStyleSelect.reducer;
